export default __webpack_public_path__ + "static/media/s.bd1089c8.png";